import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { IconProductWarning16, IconProductTrust16, IconProductHighDemand16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { LabelsLayout, TooltipLabel } from '../../components/Labels';
import {
  getIsReliable,
  getHasProblems,
  getIsEscrow,
  getDiscountMortgage,
  getReliableLabel,
} from '../../selectors/newbuilding';
import { trackLabelClick } from './tracking';
import { isReliabilityEnabledSelector } from '../../selectors/reliability/isReliabilityEnabledSelector';
import { ReliableLabel } from '../../components/Labels/ReliableLabel';

export function LabelsContainer() {
  const hasDiscountMortgage = useSelector(getDiscountMortgage);
  const isReliable = useSelector(getIsReliable);
  const hasProblems = useSelector(getHasProblems);
  const isEscrow = useSelector(getIsEscrow);
  const isReliabilityV2Enabled = useSelector(isReliabilityEnabledSelector);
  const reliableLabel = useSelector(getReliableLabel);

  const onLabelClick = (anchor: string, label: string) => (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor,
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackLabelClick(label);
  };

  return (
    <LabelsLayout>
      {hasDiscountMortgage && (
        <TooltipLabel
          background="decorative-accent-purple"
          color="decorative-theme-white"
          icon={<IconProductHighDemand16 color="icon-inverted-default" />}
          text="Льготная ипотека"
          tooltipText={
            <>
              Подробнее узнавайте <br /> у застройщика
            </>
          }
        />
      )}
      {reliableLabel && isReliabilityV2Enabled && (
        <ReliableLabel
          label={reliableLabel.title}
          reliableType={reliableLabel.type}
          onReliableClick={onLabelClick('#reliable', 'tab_reliable_dev')}
          onProblemClick={onLabelClick('#reliable', 'tab_problem_building')}
        />
      )}
      {isReliable && !isReliabilityV2Enabled && (
        <TooltipLabel
          text="Надёжный ЖК"
          background="accent-main-primary"
          color="decorative-theme-white"
          tooltipText="Подробнее о надёжности"
          icon={<IconProductTrust16 color="icon-inverted-default" />}
          onClick={onLabelClick('#reliable', 'tab_reliable_dev')}
        />
      )}
      {hasProblems && !isReliabilityV2Enabled && (
        <TooltipLabel
          text="Стройка заморожена"
          background="accent-negative-primary"
          color="decorative-theme-white"
          tooltipText="Узнать подробности"
          icon={<IconProductWarning16 color="icon-inverted-default" />}
          onClick={onLabelClick('#problem', 'tab_problem_building')}
        />
      )}
      {isEscrow && (
        <TooltipLabel
          text="Эскроу"
          background="accent-main-secondary"
          color="accent-main-primary"
          tooltipText="Подробнее об эскроу–счёте"
          onClick={onLabelClick('#escrow', 'tab_escrow')}
        />
      )}
    </LabelsLayout>
  );
}
